import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M10.813 9.281l1.406 1.438L7.938 15h20.063v2H7.938l4.281 4.281-1.406 1.438L4.094 16l.719-.719z" /></svg>);